export default {
  'projectBuilder.title': 'Constructor de proyecto',
  'projectBuilder.back': 'Volver',
  'projectBuilder.revision': 'Revisión {revision}',
  'projectBuilder.revision.number': 'Versión',
  'projectBuilder.revision.status': 'Estado',
  'projectBuilder.chat.title': 'Asistente IA',
  'projectBuilder.chat.open': 'Abrir chat',
  'projectBuilder.chat.close': 'Cerrar chat',
  'projectBuilder.readOnly': 'Solo lectura',
  'projectBuilder.active': 'Activo',
  'projectBuilder.inactive': 'Inactivo',
  'projectBuilder.settings': 'Descripción',
  'projectBuilder.more': 'Más opciones',
  'projectBuilder.menu.description': 'Editar',
  'projectBuilder.edit.title': 'Editar proyecto',
  'projectBuilder.menu.activate': 'Activar',
  'projectBuilder.menu.deactivate': 'Desactivar',
  'projectBuilder.menu.delete': 'Eliminar',
  'projectBuilder.error.notFound': 'El proyecto no existe o no tienes acceso',
  'projectBuilder.error.readOnly': 'No tienes permiso para modificar este proyecto',

  'projectBuilder.section.canvas': 'Lienzo',
  'projectBuilder.section.artifacts': 'Recursos',
  'projectBuilder.section.collaborators': 'Colaboradores',
  'projectBuilder.section.access': 'Acceso de uso',
  'projectBuilder.section.documents': 'Documentos',

  'projectBuilder.canvas.empty': 'El proyecto todavía no tiene recursos',
  'projectBuilder.canvas.empty.hint':
    'Asocia recursos en cada grupo, o pídele al asistente que arme la solución.',
  'projectBuilder.map.data': 'Datos',
  'projectBuilder.map.data.hint': 'Entidades y listas',
  'projectBuilder.map.operation': 'Operación',
  'projectBuilder.map.operation.hint': 'Procesos y apps',
  'projectBuilder.map.intelligence': 'Inteligencia',
  'projectBuilder.map.intelligence.hint': 'Agentes y skills',
  'projectBuilder.map.organization': 'Organización',
  'projectBuilder.map.organization.hint': 'Áreas, puestos y grupos',
  'projectBuilder.map.count': '{count} recursos',
  'projectBuilder.artifacts.empty': 'Todavía no hay recursos de este tipo',
  'projectBuilder.artifacts.add': 'Asociar',
  'projectBuilder.artifacts.open': 'Abrir',
  'projectBuilder.artifacts.unlink': 'Desvincular',
  'projectBuilder.artifacts.refresh': 'Actualizar nombre',
  'projectBuilder.artifacts.unavailable': 'No disponible',
  'projectBuilder.artifacts.unavailable.hint':
    'El recurso ya no está o no puedes verlo. Puedes quitar la asociación.',
  'projectBuilder.artifacts.picker.title': 'Asociar {type}',
  'projectBuilder.artifacts.picker.search': 'Buscar',
  'projectBuilder.artifacts.picker.empty': 'No hay resultados',
  'projectBuilder.artifacts.unlink.confirm':
    'Se quita la asociación con el proyecto. El recurso sigue existiendo y se administra en su propia pantalla.',

  'projectBuilder.artifact.app': 'Apps',
  'projectBuilder.artifact.dynamic-entity': 'Entidades',
  'projectBuilder.artifact.custom-list': 'Listas',
  'projectBuilder.artifact.process': 'Procesos',
  'projectBuilder.artifact.ai-agent': 'Agentes',
  'projectBuilder.artifact.ai-skill': 'Skills',
  'projectBuilder.artifact.area': 'Áreas',
  'projectBuilder.artifact.position': 'Puestos',
  'projectBuilder.artifact.user-group': 'Grupos de usuarios',

  'projectBuilder.listType.list': 'Tabla',
  'projectBuilder.listType.gantt': 'Gantt',
  'projectBuilder.listType.calendar': 'Calendario',
  'projectBuilder.listType.taskList': 'Lista de tareas',
  'projectBuilder.listType.taskBoard': 'Tablero',
  'projectBuilder.listType.cards': 'Tarjetas',
  'projectBuilder.listType.map': 'Mapa',

  'projectBuilder.collaborators.add': 'Agregar colaborador',
  'projectBuilder.collaborators.empty': 'Nadie más puede administrar este proyecto',
  'projectBuilder.collaborators.warning':
    'Un colaborador puede administrar el proyecto. No recibe acceso automático a cada recurso vinculado.',
  'projectBuilder.collaborators.remove': 'Quitar',
  'projectBuilder.collaborators.remove.confirm':
    'Esta persona dejará de administrar el proyecto. El cambio se aplica en la siguiente operación.',
  'projectBuilder.collaborators.picker.title': 'Agregar colaborador',
  'projectBuilder.collaborators.picker.search': 'Buscar por nombre o correo',

  'projectBuilder.access.description':
    'Estas reglas solo permiten leer y usar el proyecto. No dan administración ni acceso a los recursos vinculados. Los grupos de usuarios se guardan, pero hoy no conceden acceso. Si la sesión no tiene área, esa categoría no se evalúa.',

  'projectBuilder.description.title': 'Descripción',
  'projectBuilder.description.label': 'Descripción',
  'projectBuilder.description.required': 'La descripción es obligatoria',
  'projectBuilder.name.required': 'El nombre es obligatorio',
  'projectBuilder.name.max': 'Máximo 50 caracteres',
  'projectBuilder.description.max': 'Máximo 250 caracteres',

  'projectBuilder.create.title': 'Nuevo proyecto',
  'projectBuilder.create.name': 'Nombre',
  'projectBuilder.create.description': 'Descripción',
  'projectBuilder.create.active': 'Activo',
  'projectBuilder.create.submit': 'Crear',
  'projectBuilder.create.success': 'Proyecto creado',

  'projectBuilder.delete.title': 'Eliminar proyecto',
  'projectBuilder.delete.body':
    'Se elimina el proyecto y sus asociaciones. Los recursos vinculados siguen existiendo y se administran en sus propias pantallas.',

  'projectBuilder.review.conflict':
    'Otra persona cambió la composición. Recargamos el proyecto. Revisa el cambio y vuelve a aplicarlo si sigue haciendo falta.',
  'projectBuilder.review.uncertain':
    'No pudimos confirmar si el cambio se guardó. Recargamos la composición antes de intentar otra vez.',
  'projectBuilder.review.retry': 'Reintentar',
  'projectBuilder.review.dismiss': 'Descartar',

  'projectBuilder.documents.kicker': 'Proyecto',
  'projectBuilder.documents.title': 'Documentos',
  'projectBuilder.documents.summary':
    'Archivos de este proyecto. La descarga usa la ruta del proyecto y el plan se conserva.',
  'projectBuilder.documents.root': 'Carpeta del proyecto',
  'projectBuilder.documents.empty': 'Esta carpeta no tiene archivos',
  'projectBuilder.documents.empty.hint': 'Sube un archivo o crea una subcarpeta.',
  'projectBuilder.documents.missing': 'Este proyecto todavía no tiene carpeta de documentos',
  'projectBuilder.documents.missing.hint': 'Al crearla, los archivos quedan solo en este proyecto.',
  'projectBuilder.documents.missing.readOnly':
    'Un administrador del proyecto tiene que crear la carpeta de documentos.',
  'projectBuilder.documents.init': 'Crear carpeta',
  'projectBuilder.documents.upload': 'Subir',
  'projectBuilder.documents.newFolder': 'Nueva carpeta',
  'projectBuilder.documents.folderName': 'Nombre de la carpeta',
  'projectBuilder.documents.createFolder': 'Crear',
  'projectBuilder.documents.download': 'Descargar',
  'projectBuilder.documents.delete': 'Eliminar',
  'projectBuilder.documents.deleteDoc.title': 'Eliminar documento',
  'projectBuilder.documents.deleteDoc.body': 'El archivo se elimina de la carpeta del proyecto.',
  'projectBuilder.documents.deleteFolder.title': 'Eliminar carpeta',
  'projectBuilder.documents.deleteFolder.body':
    'Se elimina la subcarpeta. La carpeta del proyecto se conserva.',
  'projectBuilder.documents.external':
    'Este archivo pertenece a otro origen y no se puede eliminar desde el proyecto.',
  'projectBuilder.documents.loadMore': 'Cargar más',
  'projectBuilder.plan.kicker': 'Proyecto',
  'projectBuilder.plan.title': 'Plan',
  'projectBuilder.plan.summary':
    'PLAN.md del proyecto. Guardar crea la carpeta si todavía no existe y conserva el nombre guardado.',
  'projectBuilder.plan.empty.title': 'Todavía no hay un plan',
  'projectBuilder.plan.empty.text': 'Cuando lo escribas, queda guardado como PLAN.md del proyecto.',
  'projectBuilder.plan.empty.start': 'Escribir el plan',
  'projectBuilder.plan.history': 'Revisiones',
  'projectBuilder.plan.revision': 'Revisión {number}',
  'projectBuilder.plan.viewing': 'Estás viendo la revisión {number}.',
  'projectBuilder.plan.restore': 'Traer al editor',
  'projectBuilder.plan.conflict':
    'El plan cambió. Carga la versión actual antes de guardar otra vez.',
  'projectBuilder.plan.reload': 'Cargar versión actual',
  'projectBuilder.section.plan': 'Plan',
  'projectBuilder.section.design': 'Diseño',
  'projectBuilder.diagram.preview.kicker': 'Vista previa de esta propuesta',
  'projectBuilder.diagram.live.kicker': 'Último diseño admitido',
  'projectBuilder.diagram.live.revision': 'Revisión del plan {number}',
  'projectBuilder.diagram.status.preparing': 'Preparando propuesta',
  'projectBuilder.diagram.status.needsInformation': 'Falta información',
  'projectBuilder.diagram.status.needsReview': 'Requiere revisión',
  'projectBuilder.diagram.status.ready': 'Lista para construir',
  'projectBuilder.diagram.layer.people': 'Personas y organización',
  'projectBuilder.diagram.layer.apps': 'Aplicaciones',
  'projectBuilder.diagram.layer.automation': 'Automatización',
  'projectBuilder.diagram.layer.data': 'Información y resultados',
  'projectBuilder.diagram.type.person': 'Persona',
  'projectBuilder.diagram.type.report': 'Reporte',
  'projectBuilder.diagram.type.app': 'Aplicación',
  'projectBuilder.diagram.type.dynamic-entity': 'Entidad',
  'projectBuilder.diagram.type.custom-list': 'Lista',
  'projectBuilder.diagram.type.process': 'Proceso',
  'projectBuilder.diagram.type.ai-agent': 'Agente IA',
  'projectBuilder.diagram.type.ai-skill': 'Skill',
  'projectBuilder.diagram.type.area': 'Área',
  'projectBuilder.diagram.type.position': 'Cargo',
  'projectBuilder.diagram.type.user-group': 'Grupo de usuarios',
  'projectBuilder.diagram.type.unknown': 'Componente',
  'projectBuilder.diagram.state.conceptual': 'Conceptual',
  'projectBuilder.diagram.state.planned': 'Por crear',
  'projectBuilder.diagram.state.plannedLive': 'Previsto',
  'projectBuilder.diagram.state.existing': 'Existente',
  'projectBuilder.diagram.state.building': 'En construcción',
  'projectBuilder.diagram.state.built': 'Construido',
  'projectBuilder.diagram.state.unlinked': 'Desvinculado',
  'projectBuilder.diagram.state.unavailable': 'No disponible',
  'projectBuilder.diagram.state.failed': 'Requiere atención',
  'projectBuilder.diagram.state.missing': 'Estado no disponible',
  'projectBuilder.diagram.detail.proposal.conceptual': 'Explica el sistema y no se construye.',
  'projectBuilder.diagram.detail.proposal.planned': 'Se va a crear.',
  'projectBuilder.diagram.detail.proposal.existing':
    'Ya pertenece al proyecto, o el plan lo reutiliza, lo configura o lo deja igual.',
  'projectBuilder.diagram.detail.proposal.missing':
    'Esta propuesta no informó el estado del componente.',
  'projectBuilder.diagram.detail.live.conceptual': 'Componente explicativo. No se construye.',
  'projectBuilder.diagram.detail.live.planned': 'Previsto. Todavía no hay trabajo en curso.',
  'projectBuilder.diagram.detail.live.existing': 'Ya estaba en el proyecto.',
  'projectBuilder.diagram.detail.live.building':
    'Hay trabajo en cola, en ejecución o con reintento disponible.',
  'projectBuilder.diagram.detail.live.built':
    'La construcción produjo el artefacto y sigue asociado.',
  'projectBuilder.diagram.detail.live.unlinked':
    'La construcción terminó, pero el artefacto ya no está en el proyecto.',
  'projectBuilder.diagram.detail.live.unavailable':
    'El diseño cita un artefacto que ahora no está disponible.',
  'projectBuilder.diagram.detail.live.failed':
    'Una etapa falló, o una etapa pendiente quedó bloqueada por un fallo requerido.',
  'projectBuilder.diagram.detail.live.missing': 'Estado no disponible. Vuelve a leer el diagrama.',
  'projectBuilder.diagram.action.create': 'Crear',
  'projectBuilder.diagram.action.link': 'Vincular',
  'projectBuilder.diagram.action.configure': 'Configurar',
  'projectBuilder.diagram.action.no-op': 'Mantener',
  'projectBuilder.diagram.legend.relation': 'Relación del diseño',
  'projectBuilder.diagram.legend.proposal': 'Sin orden de ejecución',
  'projectBuilder.diagram.legend.live': 'El avance se indica en los componentes',
  'projectBuilder.diagram.legend.none': 'Sin relaciones declaradas',
  'projectBuilder.diagram.empty.live.title': 'Todavía no hay un diseño admitido',
  'projectBuilder.diagram.empty.live': 'El diagrama aparecerá cuando se admita una construcción.',
  'projectBuilder.diagram.empty.live.hint':
    'La propuesta se prepara en el chat. Cuando se admita, el mapa de la solución queda en esta vista.',
  'projectBuilder.diagram.inspector.detail': 'Detalle',
  'projectBuilder.diagram.inspector.empty': 'Sin selección',
  'projectBuilder.diagram.inspector.relation': 'Relación',
  'projectBuilder.diagram.inspector.designName': 'Nombre en el diseño',
  'projectBuilder.diagram.inspector.open': 'Abrir recurso',
  'projectBuilder.diagram.inspector.incoming': 'Entra desde {name}: {label}',
  'projectBuilder.diagram.inspector.outgoing': 'Sale hacia {name}: {label}',
  'projectBuilder.diagram.error.read': 'No se pudo leer el diagrama.',
  'projectBuilder.diagram.error.denied': 'No tienes acceso a este diagrama.',
  'projectBuilder.diagram.error.edge': 'No se pudo leer una relación del diagrama.',
  'projectBuilder.diagram.retry': 'Reintentar',
  'projectBuilder.diagram.expand': 'Ampliar mapa',
  'projectBuilder.diagram.zoom.in': 'Acercar',
  'projectBuilder.diagram.zoom.out': 'Alejar',
  'projectBuilder.diagram.zoom.fit': 'Ajustar',
  'projectBuilder.diagram.zoom.reflow': 'Reorganizar vista',
};
